import { render, staticRenderFns } from "./BindOtherWechatDialog.vue?vue&type=template&id=7a9db216&scoped=true"
import script from "./BindOtherWechatDialog.vue?vue&type=script&lang=ts"
export * from "./BindOtherWechatDialog.vue?vue&type=script&lang=ts"
import style0 from "./BindOtherWechatDialog.vue?vue&type=style&index=0&id=7a9db216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9db216",
  null
  
)

export default component.exports